export default {
  pages: {
    key: "title",
    data: [
      { title: "Home", url: "/", icon: "HomeIcon", is_bookmarked: false },
      { title: "Page 3", url: "/page3", icon: "FileIcon", is_bookmarked: false }
    ]
  }
};
